export enum CrmIntegrations {
  SALESFORCE = 'CrmIntegrations::Salesforce',
}

export type CrmSetting = {
  id: number;
  type: CrmIntegrations;
  crm_connected: boolean;
  instance_url: string;
  api_version: string;
  client_id_present: boolean;
  client_secret_present: boolean;
};
